// MiniDrawerStyled.js
// material-ui
import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';

// project imports
import { DRAWER_WIDTH } from 'config';

const openedMixin = (theme, headerColor) => {
  // const activeBg = headerColor || '#485D9A';
  // const activeGradient = headerColor ? 'linear-gradient(90deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0) 100%)' : 'none';
  const hoverGradient = headerColor ? 'linear-gradient(90deg, rgba(0, 0, 0, 0.05) 0%, rgba(255, 255, 255, 0) 100%)' : 'none';
  // const activeShadow = headerColor ? '0 4px 15px rgba(0, 0, 0, 0.15)' : 'none';

  return {
    width: DRAWER_WIDTH,
    borderRight: `1px solid ${theme.palette.divider}`, // Tambah border tipis agar tidak menyatu dengan konten
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    overflowX: 'hidden',
    boxShadow: 'none',
    ...theme.applyStyles?.('dark', { boxShadow: theme.customShadows?.z1 }),

    '& .MuiDrawer-paper': {
      width: DRAWER_WIDTH,
      boxSizing: 'border-box',
      overflowX: 'hidden',
      backgroundColor: '#ffffff', // Background drawer putih
      color: theme.palette.text.primary, // Warna teks default gelap
      borderRight: `1px solid ${theme.palette.divider}`,
      paddingTop: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    // hilangkan garis bawah antar item
    '& .MuiListItem-root, & .MuiListItemButton-root': {
      borderBottom: 'none'
    },
    '& .MuiDivider-root': {
      display: 'none'
    },
    '& .MuiList-root': {
      paddingTop: 0
    },

    // === Style Inactive Tab ===
    '& .MuiListItemButton-root': {
      borderRadius: theme.shape?.borderRadius ? theme.shape.borderRadius * 4 : 12,
      marginBottom: theme.spacing(0.5), // Jarak antar menu
      transition: 'all 0.3s ease'
    },

    // === Style Hover untuk Inactive Tab ===
    '& .MuiListItemButton-root:hover:not(.Mui-selected)': {
      backgroundColor: 'rgba(72, 93, 154, 0.08)', // Efek hover biru sangat tipis
      backgroundImage: hoverGradient
    }
  };
};

const closedMixin = (theme, headerColor) => {
  // const activeBg = headerColor || '#485D9A';
  // const activeGradient = headerColor ? 'linear-gradient(90deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0) 100%)' : 'none';
  const hoverGradient = headerColor ? 'linear-gradient(90deg, rgba(0, 0, 0, 0.05) 0%, rgba(255, 255, 255, 0) 100%)' : 'none';
  // const activeShadow = headerColor ? '0 4px 15px rgba(0, 0, 0, 0.15)' : 'none';

  return {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: theme.spacing(8.5), // Disesuaikan agar icon tidak terlalu sempit
    borderRight: `1px solid ${theme.palette.divider}`,

    '& .MuiDrawer-paper': {
      width: theme.spacing(8.5),
      boxSizing: 'border-box',
      overflowX: 'hidden',
      backgroundColor: '#ffffff', // Background drawer putih
      color: theme.palette.text.primary,
      borderRight: `1px solid ${theme.palette.divider}`,
      paddingTop: theme.spacing(2),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    },

    // === Style Inactive Tab ===
    '& .MuiListItemButton-root': {
      justifyContent: 'center',
      px: 0,
      marginBottom: theme.spacing(1),
      borderRadius: theme.shape?.borderRadius ? theme.shape.borderRadius * 4 : 12,
      transition: 'all 0.3s ease',
      '& .MuiListItemIcon-root': {
        minWidth: 'auto'
      }
    },
    '& .MuiListItem-root, & .MuiListItemButton-root': {
      borderBottom: 'none'
    },
    '& .MuiDivider-root': {
      display: 'none'
    },

    // === Style Hover untuk Inactive Tab ===
    '& .MuiListItemButton-root:hover:not(.Mui-selected)': {
      backgroundColor: 'rgba(72, 93, 154, 0.08)',
      backgroundImage: hoverGradient
    }
  };
};

// ==============================|| DRAWER - MINI STYLED ||============================== //
const MiniDrawerStyled = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' && prop !== 'headerColor' })(
  ({ theme, open, headerColor }) => ({
    width: DRAWER_WIDTH,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open ? openedMixin(theme, headerColor) : closedMixin(theme, headerColor))
  })
);

export default MiniDrawerStyled;
